import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { PropType } from 'vue';
import { ArrowCircleDownIcon, ArrowCircleUpIcon } from '@heroicons/vue/solid';
import { SortMenuItem, SortMenuItemDirection } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiSortMenuBadge',
  props: {
    item: {
        type: Object as PropType<SortMenuItem>,
        required: true,
    },
},
  emits: ['remove'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleRemoveClick = (item: SortMenuItem) => {
    emit('remove', item);
};

return (_ctx: any,_cache: any) => {
  const _component_UiBadge = _resolveComponent("UiBadge")!

  return (_openBlock(), _createBlock(_component_UiBadge, {
    removable: "",
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (handleRemoveClick(props.item)))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(
                props.item.direction == _unref(SortMenuItemDirection).ASC
                    ? _unref(ArrowCircleDownIcon)
                    : _unref(ArrowCircleUpIcon)
            ), {
        class: "text-primary h-4 w-4 cursor-pointer",
        "aria-hidden": "true"
      })),
      _createTextVNode(" " + _toDisplayString(props.item.label), 1)
    ]),
    _: 1
  }))
}
}

})